const status = [
  "ALL",
  "PROGRESS",
  "DELIVERING",
  "PICKUP",
  "SUCCESS",
  "FAIL",
  "CANCELBYDRIVER",
  "CANCELBYADMIN",
  "FINDDRIVER",
];

export const statusByRouteName = {
  ProgressOrder: ["ALL", "FINDDRIVER", "CANCELBYADMIN", "CANCELBYDRIVER", "PROGRESS"],
  ShippingOrder: ["ALL", "PICKUP", "DELIVERING"],
  HistoryOrder: ["ALL", "SUCCESS"],
};

export default status;
